import { render, staticRenderFns } from "./selectRecommendations.vue?vue&type=template&id=7ce7f088"
import script from "./selectRecommendations.vue?vue&type=script&lang=js"
export * from "./selectRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports